import React from "react";
import "./styles.css";

type TProps = {
    title: string;
}

const PageTitle = ({ title }: TProps) => {
    return (
        <div className="title_container">
            <span
                className="title_text"
                style={{
                    fontWeight: "bold",
                    fontSize: "1.5rem",
                }}
            >
                {title}
            </span>
        </div>
    );
}

export default React.memo(PageTitle);